import { Button } from "@sellar-io/components";
import { useState } from "react";
import { useNavigate } from "react-router";
import { SpinnerLegacy } from "../../../../components";
import { Alert } from "../../../../components/alert/Alert";
import {
  Dialog,
  DialogNavigation,
  DialogCTA,
} from "../../../../components/modal/Dialog";
import { NavigationBar } from "../../../../components/navigation/NavigationBar";
import {
  EDIT_PRODUCT,
  PRODUCT_LIST,
  PRODUCT_LIST_CATEGORY,
} from "../../../../constants/routes";
import { useParamAsNumber } from "../../../../hooks/useParamAsNumber";
import { apiV2AssertError } from "../../../../hooks/api/v2/apiV2Request";
import { useSupplierProduct } from "../../../../hooks/api/v2/product/useSupplierProduct";
import { useProductDelete } from "../../../../hooks/api/v2/product/useProductDelete";
import { useProductUpdate } from "../../../../hooks/api/v2/product/useProductUpdate";
import ProductItemFormV3 from "./ProductItemFormV3";

export const ProductEditV2 = () => {
  const productId = useParamAsNumber(EDIT_PRODUCT, "productId");
  const navigate = useNavigate();

  const productQuery = useSupplierProduct(productId);

  const productDeleteMutation = useProductDelete(productId);

  const productUpdateMutation = useProductUpdate(productId);

  const [active, setActive] = useState<boolean>(false);

  const onDismiss = () => setActive(false);

  return (
    <>
      <NavigationBar
        title={
          productQuery.isLoading
            ? "Loading..."
            : (productQuery.data?.name ?? "")
        }
        leftIcon={"CHEVRON_LEFT"}
        onClickLeftIcon={() =>
          navigate(PRODUCT_LIST_CATEGORY.href({ productId }))
        }
      />
      {productQuery.isLoading ||
      productUpdateMutation.isPending ||
      !productQuery.data ? (
        <SpinnerLegacy />
      ) : (
        <div className="mx-auto max-w-[900px] p-2 lg:py-10">
          {productUpdateMutation.isError && (
            <Alert
              type={"error"}
              message={
                apiV2AssertError(productUpdateMutation.error)?.response?.data
                  .message ?? "Unknown error"
              }
            />
          )}
          <ProductItemFormV3
            product={productQuery.data}
            onSubmit={(product) =>
              productUpdateMutation.mutate(product, {
                onSuccess: () =>
                  navigate(PRODUCT_LIST_CATEGORY.href({ productId })),
              })
            }
            onDelete={() => setActive(true)}
          />
        </div>
      )}
      <Dialog active={active} onDismiss={onDismiss}>
        <DialogNavigation
          onClickLeftIcon={onDismiss}
          leftIcon={"CHEVRON_DOWN"}
          title={"Delete Product"}
          description={
            "You are about to delete this product from your account. Items for this product will only be accessible for order history. This action is irreversible."
          }
        />
        {productDeleteMutation.isError && (
          <Alert
            type={"error"}
            message={
              apiV2AssertError(productDeleteMutation.error)?.response?.data
                .message ?? "Unknown error"
            }
          />
        )}
        <DialogCTA>
          <Button
            loading={productDeleteMutation.isPending}
            onClick={() => {
              productDeleteMutation.mutate(undefined, {
                onSuccess: () => navigate(PRODUCT_LIST),
              });
            }}
          >
            Delete product
          </Button>
        </DialogCTA>
      </Dialog>
    </>
  );
};
